// extracted by mini-css-extract-plugin
export default {"assignmentWrapper":"AvailableAssignment_assignmentWrapper__21txQ","marginTop":"AvailableAssignment_marginTop__Tv3o2"};